import { SpinnerLoader } from '@assets/icons'
import { IColumn } from '@interfaces/index'
import React from 'react'
interface IProps<T> {
    data: T[]
    columns: IColumn<T>[]
    isLoading: boolean
    isUnitRegistrationRow?: boolean
    onLineClick?: (item: T) => void
}

export default function TableGeneric<T>(props: IProps<T>): React.ReactElement {
    return (
        <div className="table-generic-box">
            <table className="table-generic small-2">
                <thead>
                    <tr>
                        {props.columns.map((column, keyColumn) => (
                            <th
                                className={column.align ?? 'align-left'}
                                key={keyColumn}
                                style={{ width: column.size ?? 'auto', minWidth: column.minWidth ?? 'auto' }}
                            >
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                {props.isLoading ?
                    <tbody className='loader'>
                        <tr>
                            <td>
                                <SpinnerLoader />
                            </td>
                        </tr>
                    </tbody>
                    :
                    <tbody>
                        {props.data.length ? (
                            props.data.map((item, keyItem) => {
                                return (
                                    <tr key={keyItem} onClick={() => {
                                        if (props.onLineClick) { props.onLineClick(item) }
                                    }}>
                                        <>
                                            {props.columns.map((cell, keyCell) => (
                                                <td
                                                    style={{ paddingRight: cell.paddingRight ?? 'auto' }}
                                                    className={`${cell.align ?? 'aling-left'}`} key={keyCell}>
                                                    {cell.render ? cell.render(item) : (item[cell.dataIndex as keyof T] as JSX.Element)}
                                                </td>
                                            ))}
                                        </>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr className='no-record-line'>
                                <td className="no-records small-2">
                                    Não há dados para exibir
                                </td>
                            </tr>
                        )}
                    </tbody>
                }
            </table>
        </div>
    )
}
